import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SetujNadredjeneEntiteteZaUnosOJService {
  private data = new BehaviorSubject<KreiranjeOJModel>(null);
  public currentData = this.data.asObservable();

  constructor() { }

  setujPodatkeZaKreiranjeOJ(data: KreiranjeOJModel) {
    this.data.next(data);
  }
}

export class KreiranjeOJModel {
  idNadredjeneOJ: number;
  sifraNadredjeneOJ: string;
  nazivNadredjeneOJ: string;
}
